export default __webpack_public_path__ + "static/PAPC_2022_schedule_final-f607a52490ae1ad7da50b14a6a9dbfd6.pdf";